module.exports = __webpack_public_path__ + "img/training.351b2613.svg";